import type { Filter } from './SortField.types.tsx';

const HIERARCHY_LEVEL = 'hierarchy-level' as const;

export const MAX_RESULTS = 15;

export const DEFAULT_FILTER: Filter = {
	page: 1,
	sortDirection: 'DESC',
	sortField: HIERARCHY_LEVEL,
};
